module.exports = __webpack_public_path__ + "img/BlinkArt_Mace2H_Epic.36e0bdcd.png";